export default __webpack_public_path__ + "src/static/img/png/visa-global-registry.png";